import React from 'react';
import styled from "styled-components";
import NotificationModal from "../../components/NotificationModal";
import RotationAnimationWrapper from "../../components/Wrappers/RotationAnimationWrapper";
import TutorialSplashScreenIcon from "../../components/Images/TutorialSplashScreenIcon";
import ActionButton from "../../components/Buttons/ActionButton";
import router from "../../router/router";


const TutorialSplashScreen: React.FC = () => {

    const clickHandler = () => {
        router.navigate('main')
    }

    return (
        <Container>
                <NotificationModal/>
                    <Wrapper>
                        <div style={{textAlign: "center" }}>
                            <h1 style={{fontSize:28, fontWeight:700}}>Decode and Earn</h1>
                            <p style={{fontSize: 15, fontWeight:600, marginTop: 12, marginBottom:16}}>Collect symbols, hack the codes,<br/> and earn rewards!</p>
                            <p style={{fontSize: 15, fontWeight:600, marginTop: 12, marginBottom:16}}>Start a quick
                                tutorial.</p>
                        </div>
                        <CirclePositionWrapper>
                           <RotationAnimationWrapper duration={20}>
                               <TutorialSplashScreenIcon/>
                           </RotationAnimationWrapper>
                       </CirclePositionWrapper>
                        <ActionButton width="calc(100% - 48px)" height="48px" type="active"
                                      clickHandler={clickHandler}>earn rewards</ActionButton>
                    </Wrapper>
        </Container>
    );
}

export default TutorialSplashScreen;

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    `;
const Container = styled.div`
    height: 100%;
    position: relative;
`;
const CirclePositionWrapper = styled.div`
    position: relative;
    width: 300px;
    height: 300px;
`
